import React from 'react'

import { useHistory } from 'react-router-dom'

import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'

export default function DocumentationListPage() {
    const history = useHistory();
    
    return (
        <div>
            <Row>
                <Col sm={12} md={6} lg={6}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Markdown Cheatsheet</Card.Title>
                            <p>Eine einfache und kurze Dokumentation über das Campboard Markdown mit interaktiven Beispielen.</p>
                            <Button className="m-0" onClick={() => history.push('/documentation/markdown/')}>Ansehen</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}
